import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';

export default function RecommendationsPanel({ recommendations }) {
  if (recommendations.length === 0) return null;

  return (
    <div className="mt-8">
      <h3 className="text-xl font-semibold text-gray-50 mb-4">Recommendations</h3>

      <div className="space-y-3">
        {recommendations.map((rec, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.0 + idx * 0.1 }}
            className="bg-slate-900 border border-white/10 rounded-lg p-4 hover:bg-slate-800 transition-colors"
          >
            <div className="flex items-start gap-3">
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  rec.severity === 'critical'
                    ? 'bg-red-500/20 text-red-400'
                    : rec.severity === 'important'
                      ? 'bg-amber-500/20 text-amber-400'
                      : 'bg-blue-500/20 text-blue-400'
                }`}
              >
                <Lightbulb className="w-4 h-4" />
              </div>

              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-50 mb-1">{rec.title}</h4>
                <p className="text-sm text-gray-400">{rec.description}</p>
                {rec.example && (
                  <p className="text-xs text-gray-500 mt-2 italic">Example: {rec.example}</p>
                )}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
